function firstTruthy(...values) {
  return values.find((value) => value !== undefined && value !== null && value !== '') || ''
}

function stripBearerPrefix(value) {
  return String(value || '').replace(/^Bearer\s+/i, '')
}

function normalizeRole(value) {
  if (typeof value === 'number') {
    return value
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    const numericRole = Number(trimmed)

    if (!Number.isNaN(numericRole)) {
      return numericRole
    }

    if (/admin|管理员|企业管理/i.test(trimmed)) {
      return 2
    }

    if (/employee|staff|user|员工/i.test(trimmed)) {
      return 3
    }
  }

  return value
}

function looksLikeUserPayload(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false
  }

  return [
    'id',
    'userId',
    'username',
    'userName',
    'account',
    'role',
    'roleId',
    'companyId',
    'company_id'
  ].some((key) => Object.prototype.hasOwnProperty.call(value, key))
}

function normalizeSessionPayload(payload) {
  const data = payload?.data && typeof payload.data === 'object' ? payload.data : {}
  const rawUser = payload?.user || data.user || data.userInfo || data.currentUser || (looksLikeUserPayload(data) ? data : {})
  const rawCompany = payload?.company || data.company || data.companyInfo || rawUser.company || {}
  const role = normalizeRole(rawUser.role ?? rawUser.roleId ?? rawUser.userRole)
  const token = stripBearerPrefix(
    firstTruthy(
      payload?.token,
      payload?.accessToken,
      payload?.jwtToken,
      payload?.authorization,
      data.token,
      data.accessToken,
      data.jwtToken,
      data.authorization,
      rawUser.token,
      rawUser.accessToken,
      rawUser.jwtToken,
      rawUser.authorization
    )
  )

  const user = {
    ...rawUser,
    id: rawUser.id ?? rawUser.userId ?? null,
    username: rawUser.username || rawUser.userName || rawUser.account || rawUser.name || '',
    role,
    company_id: rawUser.company_id ?? rawUser.companyId ?? rawCompany.id ?? null,
    company_name: rawUser.company_name || rawUser.companyName || rawCompany.name || '',
    roleLabel:
      rawUser.roleLabel ||
      rawUser.roleName ||
      (role === 2 ? '企业管理员' : role === 3 ? '员工' : '超级管理员')
  }

  const company = {
    ...rawCompany
  }

  return {
    token,
    user,
    company
  }
}

function hasValidSession(payload) {
  const session = normalizeSessionPayload(payload)

  return Boolean(session.token)
}

export { hasValidSession, normalizeSessionPayload }
